import Link from "next/link";
import React from "react";

interface ICustomButton {
  variant?: string;
  children?: React.ReactNode | string;
  className?: string;
  color?: string;
  textColor?: string;
  hoverColor?: string;
  hoverText?: string;
  hoverBg?: string;
  onClick?: (input?: any) => void; // TODO: onClick is a function
  isFullWidth?: boolean;
  href?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullHeight?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const LinkButton = React.forwardRef<any, ICustomButton>((props, ref) => {
  const {
    disabled,
    children,
    className,
    color,
    textColor,
    hoverColor,
    isFullWidth,
    href,
    fullHeight,
  }: any = props;
  return (
    <a ref={ref} href={href}>
      <button
        disabled={disabled}
        // {...props}
        className={`py-8
      text-16 
        ${fullHeight && "h-full"}
        min-w-[90px] rounded-12   px-16 text-center   leading-24 sm:min-w-[140px] sm:px-32
        ${color ? color : disabled ? "bg-gray-C4C4C4" : "bg-primary-main"}
        ${hoverColor ? hoverColor : disabled ? "bg-gray-C4C4C4" : "hover:bg-primary-dark"}
        ${textColor ? textColor : "text-white"}
        ${!isFullWidth ? "px-44" : ""}
        ${isFullWidth ? "w-full" : ""}
        transition ease-in-out
        ${className || " "}
      `}
      >
        {children}
      </button>
    </a>
  );
});

LinkButton.displayName = "LinkButton";

const CustomButton = ({
  variant = "contained",
  disabled,
  children,
  className,
  color,
  textColor,
  hoverColor,
  hoverText, // font-color change when hovered on button
  hoverBg, // background-color change when hovered on button
  onClick,
  isFullWidth,
  href,
  leftIcon,
  rightIcon,
  fullHeight,
  type,
  ...props // like type, ...
}: ICustomButton) => {
  return href && variant === "contained" ? (
    <Link href={href} passHref prefetch={false} legacyBehavior>
      <LinkButton
        disabled={disabled}
        className={className}
        color={color}
        textColor={textColor}
        hoverColor={hoverColor}
        isFullWidth={isFullWidth}
        href={href}
        fullHeight={fullHeight}
        {...props}
      >
        {children}
      </LinkButton>
    </Link>
  ) : variant === "outlined" ? (
    // Styles are done
    // TODO: aplly transition for color change of hover
    <button
      disabled={disabled}
      type={type}
      className={` bg-transparent py-8 
          ${hoverText ? hoverText : "hover:!text-white"}
          ${hoverBg ? hoverBg : disabled ? "bg-gray-C4C4C4" : "hover:bg-primary-dark"}
          ${textColor ? textColor : "text-primary-main"}
          min-w-[90px] border sm:min-w-[140px]
          ${color ? color : disabled ? "bg-gray-C4C4C4" : "border-primary-main"}
          ${
            isFullWidth ? "w-full" : ""
          } rounded-12   px-16   text-12 leading-24 transition ease-in-out sm:px-32 sm:text-16
          ${className || " "}
      `}
      {...props}
      onClick={onClick}
    >
      <div className="flex items-center justify-center">
        {!!rightIcon && <span className="me-8">{rightIcon}</span>}
        {children}
        {!!leftIcon && <span className="ms-8">{leftIcon}</span>}
      </div>
    </button>
  ) : variant === "text" ? (
    <button
      disabled={disabled}
      {...props}
      className={`flex h-full min-w-[90px]  items-center justify-center rounded-12 py-8   px-16   text-primary-main hover:bg-primary-main hover:text-white sm:min-w-[140px] sm:px-32 ${
        className || " "
      } text-12 leading-24 transition ease-in-out md:text-16`}
      onClick={onClick}
      type={type}
    >
      <div className="flex items-center justify-center">
        {rightIcon && <span className="flex items-center me-8">{rightIcon}</span>}
        <span className={`${textColor}`}>{children}</span>
        {leftIcon && <span className="flex items-center ms-8">{leftIcon}</span>}
      </div>
    </button>
  ) : (
    <button
      disabled={disabled}
      {...props}
      className={`
      py-8  text-16
        ${fullHeight && "h-full"}
        min-w-[90px] rounded-12   px-16 text-center   leading-24 sm:min-w-[140px] sm:px-32
        ${color ? color : disabled ? "bg-gray-C4C4C4" : "bg-primary-main"}
        ${hoverColor ? hoverColor : disabled ? "bg-gray-C4C4C4" : "hover:bg-primary-dark"}
        ${textColor ? textColor : "text-white"}
        ${!isFullWidth ? "px-44" : ""}
        ${isFullWidth ? "w-full" : ""}
        transition ease-in-out
        ${className || " "}
      `}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
};

export { CustomButton };
